import { RoleDto } from '@/api/ApiClient';

// Role constants matching the backend/Knockout client
export const ROLE_IDS = {
  Community: 1,
  ProjectUserPI: 2,
  ProjectFaculty: 3,
  ProjectStaff: 4,
} as const;

export type RoleId = (typeof ROLE_IDS)[keyof typeof ROLE_IDS];

/**
 * Checks if a role ID represents an "other collaborator" role
 * (not PI, Faculty, or Staff - these are managed separately in the main project details)
 * Based on the Knockout logic in Role.ts
 */
export function isOtherCollaboratorRole(roleId: number | undefined | null): boolean {
  if (roleId === undefined || roleId === null) {
    return false;
  }

  return (
    roleId > 0 &&
    roleId !== ROLE_IDS.ProjectUserPI &&
    roleId !== ROLE_IDS.ProjectFaculty &&
    roleId !== ROLE_IDS.ProjectStaff
  );
}

/**
 * Checks if a role ID represents a PI role
 */
export function isPIRole(roleId: number | undefined | null): boolean {
  return roleId === ROLE_IDS.ProjectUserPI;
}

/**
 * Checks if a role ID represents a Faculty role
 */
export function isFacultyRole(roleId: number | undefined | null): boolean {
  return roleId === ROLE_IDS.ProjectFaculty;
}

/**
 * Checks if a role ID represents a Staff role
 */
export function isStaffRole(roleId: number | undefined | null): boolean {
  return roleId === ROLE_IDS.ProjectStaff;
}

/** Role options assignable for additional project collaborators (excludes PI, Faculty, Staff). */
export function filterOtherProjectRoles(roles: RoleDto[] | undefined): RoleDto[] {
  return roles?.filter((role) => !role.isUser && isOtherCollaboratorRole(role.id)) ?? [];
}
